(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expandable-collections"] && !Shopify.designMode) return;
  try {
    
  class TzExpandingCollections {
    constructor(section) {
      this.section = section;
      this.rail = section.querySelector('[data-tz-rail]');
      this.cards = Array.from(section.querySelectorAll('[data-tz-card]'));
      this.toggles = Array.from(section.querySelectorAll('[data-tz-toggle]'));
      this.previous = section.querySelector('[data-tz-prev]');
      this.next = section.querySelector('[data-tz-next]');
      this.progress = section.querySelector('[data-tz-progress]');
      this.expandedIndex = this.cards.findIndex((card) =>
        card.classList.contains('is-expanded')
      );
      this.dragEnabled = section.dataset.drag === 'true';
      this.tiltEnabled = section.dataset.tilt === 'true';
      this.dragStart = null;
      this.dragScroll = 0;
      this.dragMoved = false;
      this.scrollFrame = null;
      this.reducedMotion = window
        .matchMedia('(prefers-reduced-motion: reduce)')
        .matches;

      if (!this.rail || !this.cards.length) return;

      this.bind();
      this.prepareEntrance();
      this.updateProgress();

      if (this.expandedIndex >= 0) {
        this.updateAccessibility();
      }
    }

    bind() {
      this.toggles.forEach((toggle, index) => {
        toggle.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggle(index);
        });
      });

      this.previous?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));

      this.rail.addEventListener(
        'scroll',
        () => {
          if (this.scrollFrame) {
            cancelAnimationFrame(this.scrollFrame);
          }

          this.scrollFrame = requestAnimationFrame(() =>
            this.updateProgress()
          );
        },
        { passive: true }
      );

      this.section.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.expandedIndex >= 0) {
          this.collapse(this.expandedIndex, true);
        }

        if (event.key === 'ArrowLeft' && !event.target.closest('a')) {
          this.move(-1);
        }

        if (event.key === 'ArrowRight' && !event.target.closest('a')) {
          this.move(1);
        }
      });

      if (this.dragEnabled) {
        this.bindDrag();
      }

      if (this.tiltEnabled) {
        this.cards.forEach((card) => {
          card.addEventListener('pointermove', (event) =>
            this.tilt(card, event)
          );

          card.addEventListener('pointerleave', () =>
            this.resetTilt(card)
          );
        });
      }

      window.addEventListener('resize', () => this.updateProgress());
    }

    toggle(index) {
      if (this.dragMoved) return;

      if (this.expandedIndex === index) {
        this.collapse(index, true);
      } else {
        this.expand(index, true);
      }
    }

    expand(index, focus = false) {
      if (!this.cards[index]) return;

      if (
        this.expandedIndex >= 0 &&
        this.expandedIndex !== index
      ) {
        this.collapse(this.expandedIndex, false);
      }

      this.expandedIndex = index;
      this.cards[index].classList.add('is-expanded');
      this.resetTilt(this.cards[index]);
      this.updateAccessibility();

      window.setTimeout(
        () => this.centerCard(index),
        this.reducedMotion ? 0 : 120
      );

      if (focus) {
        this.toggles[index]?.focus({ preventScroll: true });
      }
    }

    collapse(index, focus = false) {
      if (!this.cards[index]) return;

      this.cards[index].classList.remove('is-expanded');

      if (this.expandedIndex === index) {
        this.expandedIndex = -1;
      }

      this.updateAccessibility();

      window.setTimeout(
        () => this.centerCard(index),
        this.reducedMotion ? 0 : 120
      );

      if (focus) {
        this.toggles[index]?.focus({ preventScroll: true });
      }
    }

    updateAccessibility() {
      this.cards.forEach((card, index) => {
        const expanded = index === this.expandedIndex;
        const title =
          card
            .querySelector('.tz-expand__collapsed-title span')
            ?.textContent?.trim() || 'collection';

        this.toggles[index]?.setAttribute(
          'aria-expanded',
          expanded ? 'true' : 'false'
        );

        this.toggles[index]?.setAttribute(
          'aria-label',
          `${expanded ? 'Close' : 'Open'} ${title}`
        );

        card
          .querySelector('[data-tz-collapsed]')
          ?.setAttribute(
            'aria-hidden',
            expanded ? 'true' : 'false'
          );

        card
          .querySelector('[data-tz-expanded]')
          ?.setAttribute(
            'aria-hidden',
            expanded ? 'false' : 'true'
          );
      });
    }

    move(direction) {
      const railCenter =
        this.rail.getBoundingClientRect().left +
        this.rail.clientWidth / 2;

      let nearest = 0;
      let distance = Infinity;

      this.cards.forEach((card, index) => {
        const box = card.getBoundingClientRect();
        const currentDistance = Math.abs(
          box.left + box.width / 2 - railCenter
        );

        if (currentDistance < distance) {
          distance = currentDistance;
          nearest = index;
        }
      });

      this.centerCard(
        Math.max(
          0,
          Math.min(
            this.cards.length - 1,
            nearest + direction
          )
        )
      );
    }

    centerCard(index) {
      const card = this.cards[index];

      if (!card) return;

      let left;

      if (window.innerWidth <= 749) {
        left = card.offsetLeft - 14;
      } else {
        left =
          card.offsetLeft -
          (this.rail.clientWidth - card.offsetWidth) / 2;
      }

      this.rail.scrollTo({
        left: Math.max(0, left),
        behavior: this.reducedMotion ? 'auto' : 'smooth'
      });
    }

    updateProgress() {
      if (!this.progress) return;

      const max = Math.max(
        1,
        this.rail.scrollWidth - this.rail.clientWidth
      );

      const visibleRatio = Math.min(
        1,
        this.rail.clientWidth / this.rail.scrollWidth
      );

      const travel = 100 - visibleRatio * 100;

      const offset =
        Math.max(
          0,
          Math.min(1, this.rail.scrollLeft / max)
        ) * travel;

      this.progress.style.width =
        `${Math.max(12, visibleRatio * 100)}%`;

      this.progress.style.transform =
        `translateX(${offset / Math.max(visibleRatio, 0.01)}%)`;
    }

    bindDrag() {
      this.rail.addEventListener('pointerdown', (event) => {
        if (
          event.pointerType === 'touch' ||
          event.target.closest('button, a')
        ) {
          return;
        }

        this.dragStart = event.clientX;
        this.dragScroll = this.rail.scrollLeft;
        this.dragMoved = false;
        this.rail.classList.add('is-dragging');
        this.rail.setPointerCapture?.(event.pointerId);
      });

      this.rail.addEventListener('pointermove', (event) => {
        if (this.dragStart === null) return;

        const distance = event.clientX - this.dragStart;

        if (Math.abs(distance) > 5) {
          this.dragMoved = true;
        }

        this.rail.scrollLeft = this.dragScroll - distance;
      });

      const stop = () => {
        this.dragStart = null;
        this.rail.classList.remove('is-dragging');

        window.setTimeout(() => {
          this.dragMoved = false;
        }, 0);
      };

      this.rail.addEventListener('pointerup', stop);
      this.rail.addEventListener('pointercancel', stop);
    }

    tilt(card, event) {
      if (
        this.reducedMotion ||
        card.classList.contains('is-expanded') ||
        event.pointerType === 'touch' ||
        window.innerWidth < 990
      ) {
        return;
      }

      const box = card.getBoundingClientRect();
      const x = (event.clientX - box.left) / box.width - 0.5;
      const y = (event.clientY - box.top) / box.height - 0.5;

      card.style.setProperty(
        '--tz-tilt-x',
        `${y * -3.5}deg`
      );

      card.style.setProperty(
        '--tz-tilt-y',
        `${x * 4.5}deg`
      );
    }

    resetTilt(card) {
      card.style.setProperty('--tz-tilt-x', '0deg');
      card.style.setProperty('--tz-tilt-y', '0deg');
    }

    prepareEntrance() {
      if (
        this.section.dataset.animation !== 'true' ||
        this.reducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        this.section.classList.add('is-visible');
        return;
      }

      this.section.classList.add('is-motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            this.section.classList.add('is-visible');

            window.setTimeout(() => {
              this.section.classList.remove('is-motion-ready');
            }, 2100);

            observer.disconnect();
          });
        },
        { threshold: 0.12 }
      );

      observer.observe(this.section);
    }
  }

  function initTzExpandingCollections(root = document) {
    const sections = [];

    if (root.matches?.('.tz-expand:not([data-tz-ready])')) {
      sections.push(root);
    }

    root
      .querySelectorAll?.('.tz-expand:not([data-tz-ready])')
      .forEach((section) => sections.push(section));

    sections.forEach((section) => {
      section.dataset.tzReady = 'true';
      section.tzExpandingCollections =
        new TzExpandingCollections(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () =>
      initTzExpandingCollections()
    );
  } else {
    initTzExpandingCollections();
  }

  document.addEventListener('shopify:section:load', (event) =>
    initTzExpandingCollections(event.target)
  );

  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest?.('[data-tz-card]');
    const instance =
      card?.closest('.tz-expand')?.tzExpandingCollections;

    if (card && instance) {
      instance.expand(Number(card.dataset.cardIndex));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  function initializeThezayverFooters(root = document) {
    const footers = root.querySelectorAll(
      '.tz-mobile-footer:not([data-footer-initialized]), .tz-footer:not([data-footer-initialized])'
    );

    footers.forEach((footer) => {
      footer.setAttribute('data-footer-initialized', 'true');

      if (
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)
      ) {
        footer.classList.add('tz-footer--visible');
        return;
      }

      footer.classList.add('tz-footer--motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('tz-footer--visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.08,
          rootMargin: '0px 0px 20px 0px'
        }
      );

      observer.observe(footer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeThezayverFooters();
    });
  } else {
    initializeThezayverFooters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeThezayverFooters(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const mobileGridInputSelector = 'input[type="radio"][name="grid-mobile"]';

  const applyMobileGridView = (input) => {
    if (!(input instanceof HTMLInputElement)) return;

    const resultsList = input.closest('results-list');
    if (!resultsList) return;

    const grid = resultsList.querySelector('[data-testid="product-grid"], .product-grid');
    if (!(grid instanceof HTMLElement)) return;

    const view = input.value === 'mobile-single' ? 'mobile-single' : 'default';

    grid.setAttribute('product-grid-view', view);

    for (const option of resultsList.querySelectorAll(mobileGridInputSelector)) {
      if (option instanceof HTMLInputElement) {
        option.checked = option.value === view;
      }
    }

    try {
      sessionStorage.setItem('product-grid-view-mobile', view);
    } catch (error) {
      /* The button must still work when browser storage is unavailable. */
    }
  };

  const restoreMobileGridView = (root = document) => {
    let storedView = 'default';

    try {
      storedView = sessionStorage.getItem('product-grid-view-mobile') || 'default';
    } catch (error) {
      storedView = 'default';
    }

    if (storedView !== 'mobile-single') storedView = 'default';

    for (const resultsList of root.querySelectorAll('results-list')) {
      const input = resultsList.querySelector(
        `${mobileGridInputSelector}[value="${storedView}"]`
      );

      if (input instanceof HTMLInputElement) {
        applyMobileGridView(input);
      }
    }
  };

  if (!document.documentElement.hasAttribute('data-zayver-mobile-grid-fix')) {
    document.documentElement.setAttribute('data-zayver-mobile-grid-fix', '');

    document.addEventListener(
      'change',
      (event) => {
        const input = event.target;

        if (
          input instanceof HTMLInputElement &&
          input.matches(mobileGridInputSelector)
        ) {
          applyMobileGridView(input);
        }
      },
      true
    );

    /* Fallback for themes where the custom change action is not dispatched. */
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const option = target.closest('.column-options__option');
        const input = option?.querySelector(mobileGridInputSelector);
        if (!(input instanceof HTMLInputElement)) return;

        window.setTimeout(() => applyMobileGridView(input), 0);
      },
      true
    );

    document.addEventListener('shopify:section:load', (event) => {
      restoreMobileGridView(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => restoreMobileGridView(), {
        once: true,
      });
    } else {
      restoreMobileGridView();
    }
  }

  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProductListDots = (root = document) => {
      const sections = root.querySelectorAll?.('.section-resource-list') || [];

      sections.forEach((section) => {
        if (section.dataset.productDotsInitialized === 'true') return;

        const dots = section.querySelector('.product-list-navigation-dots');
        if (!dots) return;

        section.dataset.productDotsInitialized = 'true';

        const getVisibleSlideshow = () => {
          const slideshows = section.querySelectorAll('slideshow-component');

          for (const slideshow of slideshows) {
            const resourceList = slideshow.closest('.resource-list');

            if (!resourceList) continue;

            const style = window.getComputedStyle(resourceList);

            if (
              style.display !== 'none' &&
              style.visibility !== 'hidden' &&
              slideshow.offsetWidth > 0 &&
              slideshow.offsetHeight > 0
            ) {
              return slideshow;
            }
          }

          return slideshows[0] || null;
        };

        const updateActiveDot = (index) => {
          const dotList = dots.querySelectorAll('.product-list-navigation-dot');
          if (!dotList.length) return;

          const safeIndex = Math.min(
            Math.max(Number(index) || 0, 0),
            dotList.length - 1
          );

          dotList.forEach((dot, dotIndex) => {
            const active = dotIndex === safeIndex;

            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        };

        dots.addEventListener('click', (event) => {
          const dot = event.target.closest('.product-list-navigation-dot');
          if (!dot) return;

          const slideshow = getVisibleSlideshow();
          if (!slideshow || typeof slideshow.select !== 'function') return;

          const index = Number(dot.dataset.productListDot);
          slideshow.select(index, event);
        });

        section.addEventListener('slideshow:select', (event) => {
          const slideshow = event.target.closest('slideshow-component');
          if (!slideshow) return;

          const resourceList = slideshow.closest('.resource-list');
          if (!resourceList) return;

          if (slideshow !== getVisibleSlideshow()) return;

          updateActiveDot(event.detail?.index ?? 0);
        });

        const syncInitialState = () => {
          const slideshow = getVisibleSlideshow();

          if (slideshow && typeof slideshow.current === 'number') {
            updateActiveDot(slideshow.current);
          } else {
            updateActiveDot(0);
          }
        };

        requestAnimationFrame(syncInitialState);
        window.addEventListener('resize', syncInitialState);
      });
    };

    const start = () => initializeProductListDots(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeProductListDots(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thezayver-categories"] && !Shopify.designMode) return;
  try {
    

  function initializeThezayverCategories(root = document) {

    const sections = root.querySelectorAll(
      '.tz-categories[data-animate="true"]:not([data-categories-initialized])'
    );


    sections.forEach((section) => {

      section.setAttribute(
        'data-categories-initialized',
        'true'
      );


      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches ||
        !('IntersectionObserver' in window)
      ) {

        section.classList.add(
          'tz-categories--visible'
        );

        return;
      }


      section.classList.add(
        'tz-categories--motion-ready'
      );


      const observer = new IntersectionObserver(

        (entries) => {

          entries.forEach((entry) => {

            if (entry.isIntersecting) {

              entry.target.classList.add(
                'tz-categories--visible'
              );

              observer.unobserve(
                entry.target
              );

            }

          });

        },

        {
          threshold: 0.1,
          rootMargin: '0px 0px -30px 0px'
        }

      );


      observer.observe(section);

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initializeThezayverCategories();

      }
    );

  } else {

    initializeThezayverCategories();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initializeThezayverCategories(
        event.target
      );

    }
  );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thezayver-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  class ThezayverCollectionShowcase {
    constructor(section) {
      this.section = section;
      this.scenes = Array.from(section.querySelectorAll('.tz-collections__scene'));
      this.cards = Array.from(section.querySelectorAll('[data-showcase-card]'));
      this.rail = section.querySelector('[data-showcase-rail]');
      this.previousButton = section.querySelector('[data-showcase-previous]');
      this.nextButton = section.querySelector('[data-showcase-next]');
      this.progress = section.querySelector('[data-showcase-progress]');
      this.currentDisplay = section.querySelector('[data-showcase-current]');
      this.status = section.querySelector('[data-showcase-status]');
      this.currentIndex = Math.max(0, this.scenes.findIndex((scene) => scene.classList.contains('is-active')));
      this.timer = null;
      this.resizeTimer = null;
      this.pointerStartX = null;
      this.pointerStartY = null;
      this.dragStartX = null;
      this.dragScrollLeft = 0;
      this.dragMoved = false;
      this.inView = false;
      this.isTransitioning = false;
      this.temporarilyPaused = false;
      this.userInteracted = false;
      this.autoplay = section.dataset.autoplay === 'true';
      this.pauseOnHover = section.dataset.pauseHover === 'true';
      this.enableSwipe = section.dataset.enableSwipe === 'true';
      this.enableTilt = section.dataset.cardTilt === 'true';
      this.speed = Number(section.dataset.autoplaySpeed || 6) * 1000;
      this.transitionDuration = Number(section.dataset.transitionDuration || 900);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.scenes.length) return;

      this.bindEvents();
      this.bindRailDrag();
      this.observeVisibility();
      this.prepareMotion();
      this.updateInterface(false);
    }

    prepareMotion() {
      if (!this.reducedMotion) this.section.classList.add('is-motion-ready');
      requestAnimationFrame(() => this.section.classList.add('is-ready'));
    }

    bindEvents() {
      this.previousButton?.addEventListener('click', () => this.previous(true));
      this.nextButton?.addEventListener('click', () => this.next(true));

      this.cards.forEach((card) => {
        card.addEventListener('click', () => {
          if (this.dragMoved) return;
          this.goTo(Number(card.dataset.goTo), undefined, true);
        });

        if (this.enableTilt) {
          card.addEventListener('pointermove', (event) => this.tiltCard(card, event));
          card.addEventListener('pointerleave', () => this.resetCard(card));
        }
      });

      this.section.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.previous(true);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.next(true);
        }
      });

      if (this.enableSwipe) {
        this.section.addEventListener('pointerdown', (event) => {
          if (event.target.closest('a, button, [data-showcase-rail]')) return;
          this.pointerStartX = event.clientX;
          this.pointerStartY = event.clientY;
        });

        this.section.addEventListener('pointerup', (event) => {
          if (this.pointerStartX === null || this.pointerStartY === null) return;
          const distanceX = event.clientX - this.pointerStartX;
          const distanceY = event.clientY - this.pointerStartY;
          this.pointerStartX = null;
          this.pointerStartY = null;
          if (Math.abs(distanceX) < 50 || Math.abs(distanceX) < Math.abs(distanceY)) return;
          distanceX > 0 ? this.previous(true) : this.next(true);
        });

        this.section.addEventListener('pointercancel', () => {
          this.pointerStartX = null;
          this.pointerStartY = null;
        });
      }

      if (this.pauseOnHover) {
        this.section.addEventListener('mouseenter', () => {
          this.temporarilyPaused = true;
          this.stopTimer();
        });
        this.section.addEventListener('mouseleave', () => {
          this.temporarilyPaused = false;
          this.startTimer();
        });
      }

      this.section.addEventListener('focusin', () => {
        this.temporarilyPaused = true;
        this.stopTimer();
      });

      this.section.addEventListener('focusout', (event) => {
        if (!this.section.contains(event.relatedTarget)) {
          this.temporarilyPaused = false;
          this.startTimer();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopTimer();
          this.pauseAllVideos();
        } else {
          this.syncVideos();
          this.startTimer();
        }
      });

      window.addEventListener('resize', () => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => {
          this.centerActiveCard(false);
          this.syncVideos();
        }, 140);
      });
    }

    bindRailDrag() {
      if (!this.rail) return;

      this.rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        this.dragStartX = event.clientX;
        this.dragScrollLeft = this.rail.scrollLeft;
        this.dragMoved = false;
        this.rail.classList.add('is-dragging');
        this.rail.setPointerCapture?.(event.pointerId);
      });

      this.rail.addEventListener('pointermove', (event) => {
        if (this.dragStartX === null) return;
        const distance = event.clientX - this.dragStartX;
        if (Math.abs(distance) > 5) this.dragMoved = true;
        this.rail.scrollLeft = this.dragScrollLeft - distance;
      });

      const endDrag = () => {
        this.dragStartX = null;
        this.rail.classList.remove('is-dragging');
        window.setTimeout(() => { this.dragMoved = false; }, 0);
      };

      this.rail.addEventListener('pointerup', endDrag);
      this.rail.addEventListener('pointercancel', endDrag);
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) {
        this.inView = true;
        this.syncVideos();
        this.startTimer();
        return;
      }

      this.visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            this.syncVideos();
            this.startTimer();
          } else {
            this.stopTimer();
            this.pauseAllVideos();
          }
        });
      }, { threshold: .18 });

      this.visibilityObserver.observe(this.section);
    }

    next(userInitiated = false) {
      this.goTo((this.currentIndex + 1) % this.scenes.length, 'next', userInitiated);
    }

    previous(userInitiated = false) {
      this.goTo((this.currentIndex - 1 + this.scenes.length) % this.scenes.length, 'previous', userInitiated);
    }

    goTo(index, forcedDirection, userInitiated = false) {
      if (index === this.currentIndex || index < 0 || index >= this.scenes.length || this.isTransitioning) return;

      const outgoing = this.scenes[this.currentIndex];
      const incoming = this.scenes[index];
      const duration = this.reducedMotion ? 0 : this.transitionDuration;
      const direction = forcedDirection || this.getDirection(index);

      if (userInitiated) this.userInteracted = true;
      this.stopTimer();
      this.isTransitioning = true;
      this.section.dataset.direction = direction;

      outgoing.classList.add('is-leaving');
      outgoing.classList.remove('is-active');
      outgoing.setAttribute('aria-hidden', 'true');
      incoming.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => incoming.classList.add('is-active'));

      this.currentIndex = index;
      this.updateInterface(true);

      window.setTimeout(() => {
        outgoing.classList.remove('is-leaving');
        this.isTransitioning = false;
        this.syncVideos();
        this.startTimer();
      }, duration + 50);
    }

    getDirection(index) {
      if (this.currentIndex === this.scenes.length - 1 && index === 0) return 'next';
      if (this.currentIndex === 0 && index === this.scenes.length - 1) return 'previous';
      return index > this.currentIndex ? 'next' : 'previous';
    }

    updateInterface(animate) {
      this.cards.forEach((card, index) => {
        const active = index === this.currentIndex;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-selected', active ? 'true' : 'false');
        if (!active) this.resetCard(card);
      });

      if (this.currentDisplay) {
        this.currentDisplay.textContent = String(this.currentIndex + 1).padStart(2, '0');
      }
      if (this.status) {
        this.status.textContent = `Collection ${this.currentIndex + 1} of ${this.scenes.length}`;
      }

      this.centerActiveCard(animate);
      this.restartProgress();
    }

    centerActiveCard(animate = true) {
      const card = this.cards[this.currentIndex];
      if (!card || !this.rail) return;
      const left = card.offsetLeft - (this.rail.clientWidth - card.offsetWidth) / 2;
      this.rail.scrollTo({ left: Math.max(0, left), behavior: animate && !this.reducedMotion ? 'smooth' : 'auto' });
    }

    startTimer() {
      this.stopTimer(false);
      if (!this.autoplay || this.temporarilyPaused || !this.inView || document.hidden || this.scenes.length < 2) return;
      this.restartProgress();
      this.timer = window.setTimeout(() => this.next(false), this.speed);
    }

    stopTimer(resetProgress = true) {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      if (resetProgress) this.progress?.classList.remove('is-running');
    }

    restartProgress() {
      if (!this.progress || !this.autoplay) return;
      this.progress.classList.remove('is-running');
      void this.progress.offsetWidth;
      this.progress.classList.add('is-running');
    }

    pauseAllVideos() {
      this.section.querySelectorAll('video').forEach((video) => video.pause());
    }

    syncVideos() {
      this.scenes.forEach((scene, index) => {
        scene.querySelectorAll('video').forEach((video) => {
          const shouldPlay = this.inView && index === this.currentIndex && video.offsetParent !== null && !document.hidden;
          if (shouldPlay) {
            video.muted = true;
            const promise = video.play();
            if (promise?.catch) promise.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }

    tiltCard(card, event) {
      if (this.reducedMotion || window.innerWidth < 990 || event.pointerType === 'touch') return;
      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;
      card.style.setProperty('--tz-card-x', `${y * -5}deg`);
      card.style.setProperty('--tz-card-y', `${x * 6}deg`);
    }

    resetCard(card) {
      card.style.setProperty('--tz-card-x', '0deg');
      card.style.setProperty('--tz-card-y', '0deg');
    }
  }

  function initializeThezayverCollectionShowcases(root = document) {
    const candidates = [];
    if (root.matches?.('.tz-collections:not([data-showcase-initialized])')) candidates.push(root);
    root.querySelectorAll?.('.tz-collections:not([data-showcase-initialized])').forEach((item) => candidates.push(item));

    candidates.forEach((showcase) => {
      showcase.dataset.showcaseInitialized = 'true';
      showcase.thezayverShowcase = new ThezayverCollectionShowcase(showcase);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeThezayverCollectionShowcases());
  } else {
    initializeThezayverCollectionShowcases();
  }

  document.addEventListener('shopify:section:load', (event) => initializeThezayverCollectionShowcases(event.target));

  document.addEventListener('shopify:block:select', (event) => {
    const scene = event.target.closest('.tz-collections__scene');
    const showcase = scene?.closest('.tz-collections')?.thezayverShowcase;
    if (scene && showcase) showcase.goTo(Number(scene.dataset.sceneIndex));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thezayver-edit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class TheZayverEdit {
      constructor(root) {
        if (!root || root.dataset.tzInitialized === 'true') return;

        this.root = root;
        this.track = root.querySelector('[data-track]');
        this.cards = Array.from(root.querySelectorAll('[data-card]'));
        this.previous = root.querySelector('[data-previous]');
        this.next = root.querySelector('[data-next]');
        this.progress = root.querySelector('[data-progress]');
        this.current = root.querySelector('[data-current]');
        this.total = root.querySelector('[data-total]');
        this.dragging = false;
        this.dragMoved = false;
        this.dragStartX = 0;
        this.dragStartScroll = 0;
        this.raf = null;

        if (!this.track || !this.cards.length) return;

        root.dataset.tzInitialized = 'true';
        this.bindEvents();
        this.prepareAnimation();
        this.update();
      }

      formatNumber(number) {
        return String(number).padStart(2, '0');
      }

      cardStep() {
        if (!this.cards[0]) return this.track.clientWidth * 0.8;
        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        return this.cards[0].getBoundingClientRect().width + gap;
      }

      scroll(direction) {
        const visibleCards = Math.max(1, Math.floor(this.track.clientWidth / this.cardStep()));
        const distance = this.cardStep() * Math.max(1, visibleCards - 1);
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      update() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const progressValue = maxScroll > 0 ? Math.min(1, Math.max(0, this.track.scrollLeft / maxScroll)) : 1;
        const activeIndex = Math.min(
          this.cards.length,
          Math.max(1, Math.round(this.track.scrollLeft / this.cardStep()) + 1)
        );

        if (this.progress) this.progress.style.transform = `scaleX(${progressValue})`;
        if (this.current) this.current.textContent = this.formatNumber(activeIndex);
        if (this.total) this.total.textContent = this.formatNumber(this.cards.length);
        if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll - 2 || maxScroll === 0;
      }

      requestUpdate() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.update());
      }

      bindEvents() {
        this.previous?.addEventListener('click', () => this.scroll(-1));
        this.next?.addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
        window.addEventListener('resize', () => this.requestUpdate(), { passive: true });

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.scroll(1);
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.scroll(-1);
          }
        });

        let dragPending = false;
        let dragPointerId = null;

        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;

          dragPending = true;
          this.dragging = false;
          this.dragMoved = false;
          dragPointerId = event.pointerId;
          this.dragStartX = event.clientX;
          this.dragStartScroll = this.track.scrollLeft;
        });

        this.track.addEventListener('pointermove', (event) => {
          if (!dragPending && !this.dragging) return;

          const distance = event.clientX - this.dragStartX;

          if (!this.dragging) {
            if (Math.abs(distance) < 8) return;

            this.dragging = true;
            this.dragMoved = true;
            this.track.classList.add('is-dragging');

            if (dragPointerId !== null && !this.track.hasPointerCapture(dragPointerId)) {
              this.track.setPointerCapture(dragPointerId);
            }
          }

          this.track.scrollLeft = this.dragStartScroll - distance;
          event.preventDefault();
        });

        const stopDragging = (event) => {
          dragPending = false;

          if (this.dragging) {
            this.dragging = false;
            this.track.classList.remove('is-dragging');
          }

          if (event.pointerId !== undefined && this.track.hasPointerCapture(event.pointerId)) {
            this.track.releasePointerCapture(event.pointerId);
          }

          dragPointerId = null;
        };

        this.track.addEventListener('pointerup', stopDragging);
        this.track.addEventListener('pointercancel', stopDragging);

        this.track.addEventListener(
          'click',
          (event) => {
            if (!this.dragMoved) return;

            event.preventDefault();
            event.stopPropagation();
            this.dragMoved = false;
          },
          true
        );
      }

      prepareAnimation() {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || !('IntersectionObserver' in window)) {
          this.root.classList.add('is-visible');
          return;
        }

        this.root.classList.add('tz-edit--motion-ready');
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.root.classList.add('is-visible');
              observer.unobserve(this.root);
            });
          },
          { threshold: 0.12 }
        );
        observer.observe(this.root);
      }
    }

    const initialize = (scope = document) => {
      scope.querySelectorAll('[id^="TheZayverEdit-"]').forEach((root) => new TheZayverEdit(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thezayver-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class ThezayverHeroPro {
    constructor(section) {
      this.section = section;
      this.slides = Array.from(section.querySelectorAll('.tz-hero__slide'));
      this.dots = Array.from(section.querySelectorAll('.tz-hero__dot'));
      this.previousButton = section.querySelector('[data-hero-previous]');
      this.nextButton = section.querySelector('[data-hero-next]');
      this.playButton = section.querySelector('[data-hero-play-toggle]');
      this.progress = section.querySelector('[data-hero-progress]');
      this.currentDisplay = section.querySelector('[data-hero-current]');
      this.status = section.querySelector('[data-hero-status]');
      this.buttons = Array.from(section.querySelectorAll('[data-hero-button]'));
      this.eyebrows = Array.from(section.querySelectorAll('[data-hero-eyebrow]'));
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.timer = null;
      this.resizeTimer = null;
      this.pointerStartX = null;
      this.pointerStartY = null;
      this.userPaused = false;
      this.temporarilyPaused = false;
      this.inView = false;
      this.hasEntered = false;
      this.isTransitioning = false;
      this.autoplay = section.dataset.autoplay === 'true';
      this.pauseOnHover = section.dataset.pauseHover === 'true';
      this.enableSwipe = section.dataset.swipe === 'true';
      this.enableParallax = section.dataset.parallax === 'true';
      this.speed = Number(section.dataset.autoplaySpeed || 6) * 1000;
      this.transitionDuration = Number(section.dataset.transitionDuration || 900);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.slides.length) return;

      this.prepareEyebrows();
      this.bindEvents();
      this.observeVisibility();
      this.prepareMotion();
      this.updateInterface();
    }

    prepareMotion() {
      if (!this.reducedMotion) this.section.classList.add('tz-hero--motion-ready');
    }

    prepareEyebrows() {
      const stagger = Number(this.section.dataset.eyebrowStagger || 45);
      const distance = Number(this.section.dataset.eyebrowDistance || 24);
      const rotation = Number(this.section.dataset.eyebrowRotate || 6);
      const hoverStrength = Number(this.section.dataset.eyebrowHoverStrength || 5);

      this.eyebrows.forEach((eyebrow) => {
        if (eyebrow.dataset.lettersReady === 'true') return;

        const text = eyebrow.textContent.trim();
        const characters = Array.from(text);
        const center = (characters.length - 1) / 2;
        const fragment = document.createDocumentFragment();

        eyebrow.dataset.lettersReady = 'true';
        eyebrow.setAttribute('aria-label', text);
        eyebrow.textContent = '';

        characters.forEach((character, index) => {
          const letter = document.createElement('span');
          const direction = index % 2 === 0 ? -1 : 1;
          const wave = ((index % 5) - 2) / 2;
          const waveY = -distance * .42 * wave;

          letter.className = 'tz-hero__eyebrow-letter';
          letter.setAttribute('aria-hidden', 'true');
          letter.textContent = character === ' ' ? '\u00A0' : character;

          if (character === ' ') letter.classList.add('tz-hero__eyebrow-letter--space');

          letter.style.setProperty('--tz-letter-delay', `${index * stagger}ms`);
          letter.style.setProperty('--tz-letter-x', `${direction * distance}px`);
          letter.style.setProperty('--tz-letter-y', `${distance}px`);
          letter.style.setProperty('--tz-letter-rotation', `${direction * rotation}deg`);
          letter.style.setProperty('--tz-letter-wave-y', `${waveY}px`);
          letter.style.setProperty('--tz-letter-wave-return', `${waveY * -.35}px`);
          letter.style.setProperty('--tz-letter-wave-rotation', `${direction * rotation * .6}deg`);
          letter.style.setProperty('--tz-letter-pulse-y', `${waveY * .45}px`);
          letter.style.setProperty('--tz-letter-hover-x', `${(index - center) * hoverStrength * .18}px`);
          letter.style.setProperty('--tz-letter-hover-y', `${wave * hoverStrength}px`);
          letter.style.setProperty('--tz-letter-hover-rotate', `${direction * hoverStrength * .7}deg`);

          fragment.appendChild(letter);
        });

        eyebrow.appendChild(fragment);
      });
    }

    bindEvents() {
      this.previousButton?.addEventListener('click', () => this.previous());
      this.nextButton?.addEventListener('click', () => this.next());

      this.buttons.forEach((button) => {
        button.addEventListener('pointermove', (event) => {
          if (this.reducedMotion || event.pointerType === 'touch') return;

          const rect = button.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;

          button.style.setProperty('--tz-button-pointer-x', `${x}%`);
          button.style.setProperty('--tz-button-pointer-y', `${y}%`);
        });

        button.addEventListener('pointerleave', () => {
          button.style.setProperty('--tz-button-pointer-x', '50%');
          button.style.setProperty('--tz-button-pointer-y', '50%');
        });
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideTo)));
      });

      this.playButton?.addEventListener('click', () => this.toggleAutoplay());

      this.section.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.previous();
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.next();
        }
      });

      if (this.enableSwipe) {
        this.section.addEventListener('pointerdown', (event) => {
          if (event.target.closest('a, button')) return;
          this.pointerStartX = event.clientX;
          this.pointerStartY = event.clientY;
        });

        this.section.addEventListener('pointerup', (event) => {
          if (this.pointerStartX === null || this.pointerStartY === null) return;

          const distanceX = event.clientX - this.pointerStartX;
          const distanceY = event.clientY - this.pointerStartY;
          this.pointerStartX = null;
          this.pointerStartY = null;

          if (Math.abs(distanceX) < 48 || Math.abs(distanceX) < Math.abs(distanceY)) return;
          distanceX > 0 ? this.previous() : this.next();
        });

        this.section.addEventListener('pointercancel', () => {
          this.pointerStartX = null;
          this.pointerStartY = null;
        });
      }

      if (this.pauseOnHover) {
        this.section.addEventListener('mouseenter', () => {
          this.temporarilyPaused = true;
          this.stopTimer();
        });

        this.section.addEventListener('mouseleave', () => {
          this.temporarilyPaused = false;
          this.startTimer();
          this.resetParallax();
        });
      }

      this.section.addEventListener('focusin', () => {
        this.temporarilyPaused = true;
        this.stopTimer();
      });

      this.section.addEventListener('focusout', (event) => {
        if (!this.section.contains(event.relatedTarget)) {
          this.temporarilyPaused = false;
          this.startTimer();
        }
      });

      if (this.enableParallax) {
        this.section.addEventListener('pointermove', (event) => this.handleParallax(event));
        this.section.addEventListener('pointerleave', () => this.resetParallax());
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopTimer();
          this.pauseAllVideos();
        } else {
          this.syncVideos();
          this.startTimer();
        }
      });

      window.addEventListener('resize', () => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.syncVideos(), 120);
      });
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) {
        this.inView = true;
        this.reveal();
        this.syncVideos();
        this.startTimer();
        return;
      }

      this.visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            this.reveal();
            this.syncVideos();
            this.startTimer();
          } else {
            this.stopTimer();
            this.pauseAllVideos();
          }
        });
      }, { threshold: .2 });

      this.visibilityObserver.observe(this.section);
    }

    reveal() {
      if (this.hasEntered) return;
      this.hasEntered = true;
      requestAnimationFrame(() => this.section.classList.add('is-ready'));
    }

    next() {
      this.goTo((this.currentIndex + 1) % this.slides.length, 'next');
    }

    previous() {
      this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length, 'previous');
    }

    goTo(index, forcedDirection) {
      if (index === this.currentIndex || this.isTransitioning || index < 0 || index >= this.slides.length) return;

      const outgoing = this.slides[this.currentIndex];
      const incoming = this.slides[index];
      const direction = forcedDirection || this.getDirection(index);
      const duration = this.reducedMotion ? 0 : this.transitionDuration;

      this.stopTimer();
      this.isTransitioning = true;
      this.section.dataset.direction = direction;

      outgoing.classList.add('is-leaving');
      outgoing.classList.remove('is-active');
      outgoing.setAttribute('aria-hidden', 'true');

      incoming.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => incoming.classList.add('is-active'));

      this.currentIndex = index;
      this.updateInterface();

      window.setTimeout(() => {
        outgoing.classList.remove('is-leaving');
        this.isTransitioning = false;
        this.syncVideos();
        this.startTimer();
      }, duration + 40);
    }

    getDirection(index) {
      if (this.currentIndex === this.slides.length - 1 && index === 0) return 'next';
      if (this.currentIndex === 0 && index === this.slides.length - 1) return 'previous';
      return index > this.currentIndex ? 'next' : 'previous';
    }

    updateInterface() {
      this.dots.forEach((dot, index) => {
        const active = index === this.currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (this.currentDisplay) {
        this.currentDisplay.textContent = String(this.currentIndex + 1).padStart(2, '0');
      }

      if (this.status) {
        this.status.textContent = `Slide ${this.currentIndex + 1} of ${this.slides.length}`;
      }
    }

    toggleAutoplay() {
      this.userPaused = !this.userPaused;
      this.playButton.dataset.paused = this.userPaused ? 'true' : 'false';
      this.playButton.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');

      if (this.userPaused) {
        this.stopTimer();
      } else {
        this.temporarilyPaused = false;
        this.startTimer();
      }
    }

    startTimer() {
      this.stopTimer(false);
      if (!this.autoplay || this.userPaused || this.temporarilyPaused || !this.inView || document.hidden || this.slides.length < 2) return;

      this.restartProgress();
      this.timer = window.setTimeout(() => this.next(), this.speed);
    }

    stopTimer(resetProgress = true) {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      if (resetProgress) this.progress?.classList.remove('is-running');
    }

    restartProgress() {
      if (!this.progress) return;
      this.progress.classList.remove('is-running');
      void this.progress.offsetWidth;
      this.progress.classList.add('is-running');
    }

    pauseAllVideos() {
      this.section.querySelectorAll('video').forEach((video) => video.pause());
    }

    syncVideos() {
      this.slides.forEach((slide, index) => {
        slide.querySelectorAll('video').forEach((video) => {
          const shouldPlay = this.inView && index === this.currentIndex && video.offsetParent !== null && !document.hidden;
          if (shouldPlay) {
            video.muted = true;
            const promise = video.play();
            if (promise?.catch) promise.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }

    handleParallax(event) {
      if (this.reducedMotion || window.innerWidth < 990 || event.pointerType === 'touch') return;
      const rect = this.section.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - .5) * -14;
      const y = ((event.clientY - rect.top) / rect.height - .5) * -10;
      this.section.style.setProperty('--tz-parallax-x', `${x}px`);
      this.section.style.setProperty('--tz-parallax-y', `${y}px`);
    }

    resetParallax() {
      this.section.style.setProperty('--tz-parallax-x', '0px');
      this.section.style.setProperty('--tz-parallax-y', '0px');
    }
  }

  function initializeThezayverHeroes(root = document) {
    const sliders = [];

    if (root.matches?.('.tz-hero:not([data-hero-initialized])')) sliders.push(root);
    root.querySelectorAll?.('.tz-hero:not([data-hero-initialized])').forEach((slider) => sliders.push(slider));

    sliders.forEach((slider) => {
      slider.dataset.heroInitialized = 'true';
      slider.thezayverHero = new ThezayverHeroPro(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeThezayverHeroes());
  } else {
    initializeThezayverHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => initializeThezayverHeroes(event.target));

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('.tz-hero__slide');
    const hero = slide?.closest('.tz-hero')?.thezayverHero;
    if (slide && hero) hero.goTo(Number(slide.dataset.slideIndex));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thezayver-manifesto"] && !Shopify.designMode) return;
  try {
    
  function initializeThezayverManifestos(root = document) {
    const sections = root.querySelectorAll(
      '.tz-manifesto[data-animate="true"]:not([data-manifesto-initialized])'
    );

    sections.forEach((section) => {
      section.setAttribute('data-manifesto-initialized', 'true');

      if (
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)
      ) {
        section.classList.add('tz-manifesto--visible');
        return;
      }

      section.classList.add('tz-manifesto--motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('tz-manifesto--visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -30px 0px'
        }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeThezayverManifestos();
    });
  } else {
    initializeThezayverManifestos();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeThezayverManifestos(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thezayver-story-preview"] && !Shopify.designMode) return;
  try {
    
  function initializeThezayverStoryPreviews(root = document) {
    const sections = root.querySelectorAll(
      '.tz-story-preview[data-animate="true"]:not([data-story-preview-initialized])'
    );

    sections.forEach((section) => {
      section.setAttribute(
        'data-story-preview-initialized',
        'true'
      );

      if (
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)
      ) {
        section.classList.add('tz-story-preview--visible');
        return;
      }

      section.classList.add('tz-story-preview--motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add(
                'tz-story-preview--visible'
              );

              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -35px 0px'
        }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeThezayverStoryPreviews();
    });
  } else {
    initializeThezayverStoryPreviews();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeThezayverStoryPreviews(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thezayver-values"] && !Shopify.designMode) return;
  try {
    
  function initializeThezayverValues(root = document) {
    const sections = [];
    if (root.matches?.('.tz-values:not([data-tz-values-initialized])')) {
      sections.push(root);
    }
    root.querySelectorAll?.('.tz-values:not([data-tz-values-initialized])').forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      section.setAttribute('data-tz-values-initialized', 'true');
      const rail = section.querySelector('.tz-values__grid');
      const cards = Array.from(section.querySelectorAll('[data-tz-value-card]'));
      const dots = Array.from(section.querySelectorAll('[data-tz-value-dot]'));
      let activeIndex = 0;
      let scrollFrame = null;

      const setActiveCard = (index) => {
        activeIndex = Math.max(0, Math.min(index, cards.length - 1));
        cards.forEach((card, cardIndex) => {
          card.classList.toggle('is-active', cardIndex === activeIndex);
        });
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const updateClosestCard = () => {
        if (!rail || !cards.length || window.innerWidth > 749) return;
        const railBox = rail.getBoundingClientRect();
        const railCenter = railBox.left + railBox.width / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        cards.forEach((card, index) => {
          const cardBox = card.getBoundingClientRect();
          const cardCenter = cardBox.left + cardBox.width / 2;
          const distance = Math.abs(railCenter - cardCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        setActiveCard(closestIndex);
      };

      setActiveCard(0);

      rail?.addEventListener('scroll', () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(updateClosestCard);
      }, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.tzValueDot);
          cards[index]?.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'start'
          });
          setActiveCard(index);
        });
      });

      cards.forEach((card, index) => {
        card.addEventListener('focus', () => {
          if (window.innerWidth <= 749) {
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            setActiveCard(index);
          }
        });

        card.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch') return;
          const bounds = card.getBoundingClientRect();
          const x = ((event.clientX - bounds.left) / bounds.width) * 100;
          const y = ((event.clientY - bounds.top) / bounds.height) * 100;
          card.style.setProperty('--tz-pointer-x', `${x}%`);
          card.style.setProperty('--tz-pointer-y', `${y}%`);
        });
      });

      window.addEventListener('resize', () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(updateClosestCard);
      });

      if (
        section.dataset.animate !== 'true' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)
      ) {
        section.classList.add('is-visible');
        return;
      }

      section.classList.add('tz-values--motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeThezayverValues();
    });
  } else {
    initializeThezayverValues();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeThezayverValues(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
